import styled, { keyframes } from 'styled-components'

import { Menu, TypeStyle } from '@syconium/little-miss-figgy'

export const fadeDownAndIn = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
`

export const Body = styled.div`
  display: flex;
  padding: 10px 0;
`

export const Menubar = styled(Menu.Menubar)`
  display: flex;
  align-items: center;
  gap: ${o => o.theme.spacing(5)};
  z-index: 4;
`

export const Label = styled(TypeStyle.HeadlineMicro)`
  color: ${o => o.theme.color.deprecated.obsidianLighter};
  margin-inline-start: auto;
  padding: 10px 0;
`

export const Overlay = styled.div<{
  active: boolean
}>`
  bottom: 0;
  display: ${o => (o.active ? 'block' : 'none')};
  height: 100%;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 2;
`
